export enum LocalStorageKey {
  IsProdMode = 'IsProdMode',
  IsErrorNotifierEnabled = 'IsErrorNotifierEnabled',
  IsEnableSnowAutomationRequestModule = 'IsEnableSnowAutomationRequestModule',
  UserTimezone = 'UserTimezoneVersion2.0',
  LanguageSettings = 'LanguageSettings',
  RecentVisitedPages = 'RecentVisitedPages',
  TableColumnsConfigurationPublisherUpdates = 'publisher-updates.columns-configuration.v1',
  SavedFiltersPublisherUpdates = 'publisher-updates.saved-filters.v1',
  SelectedFilterPublisherUpdates = 'publisher-updates.selected-filter.v1',
  ContractualOnlyPublisherUpdates = 'publisher-updates.contractual-only.v1',
}
